import { Sprite } from "./sprite";
import { ResourceStatus } from "./enums";
import { CanvasRenderer } from "./canvas-renderer";
import { Rectangle } from "./geometry";

/**
 * Manages rendering of sprites and their upload to video memory.
 */
export class SpriteManager
{
    public renderer:CanvasRenderer;
    /**
     * Queue of sprites waiting to be uploaded to video memory
     */
    private queue:Sprite[] = [];

    /**
     * Limit for maximum number of texels to be uploaded in one frame. 
     * This is not a strict limit. Single texture may exceed this limit. But no more textures will be uploaded in the frame.
     */
    public maxUploadTexels:number = 512 * 512;

    private sprites:Sprite[] = [];

    public upload()
    {
        this.uploadWaiting();
    }

    public render()
    {
        this.renderSprites();
    }

    add(s:Sprite)
    {
        if (this.sprites.indexOf(s) < 0)
        {
            if (s.status != ResourceStatus.Loading && s.status != ResourceStatus.Loaded)
                this.queue.push(s);

            this.sprites.push(s);
        }
    }

    remove(s:Sprite)
    {
        // remove sprite from rendering
        this.sprites = this.sprites.filter(e => {return e!=s;});

        // remove sprite from upload queue
        this.queue = this.queue.filter(e => {return e!=s;});

        s.free();
    }

    private renderSprites()
    {
        // order sprites by z-index, descending
        this.sprites.sort( (a:Sprite, b:Sprite) => {return b.rect.z - a.rect.z;})

        // render each sprite
        for (let i = 0; i < this.sprites.length; i++)
        {
            this.renderSprite(this.sprites[i]);
        }
    }
    private uploadWaiting()
    {
        let s:Sprite;

        // Remove all processed queue items
        while ((this.queue.length > 0) && (s = this.queue[0]) && (s.status == ResourceStatus.Loaded || s.status == ResourceStatus.Error))
        {
            this.queue.splice(0,1);
        }
        
        // Upload next items
        let uploadTexels = 0;

        for (let i = 0; i < this.queue.length && uploadTexels < this.maxUploadTexels; i++)
        {
            s = this.queue[i];
            if (s.status == ResourceStatus.Preloaded)
            {
                s.apply();

                if (s.width > 0 && s.height > 0)                
                    uploadTexels += s.width * s.height;
                else
                    uploadTexels += this.maxUploadTexels;
            }
        }
    }

    private renderSprite(s:Sprite)
    {
        if (s.status == ResourceStatus.Loaded)
        {            
            this.renderer.ctx.globalAlpha = s.opacity;
            
            this.renderer.image(s.image, s.rect.screenPosition.x - 0.5 * s.rect.screenWidth, s.rect.screenPosition.y - 0.5 * s.rect.screenHeight, s.rect.screenWidth, s.rect.screenHeight);
            
            this.renderer.ctx.globalAlpha = 1;    

            // Fade-in of sprites
            if (s.fadeIn > 0)
            {
                if (s.opacity < 1) 
                    s.opacity += s.fadeIn;
                if (s.opacity >= 1) 
                {
                    s.opacity = 1;
                    s.fadeIn = 0;
                }
                    
            }
            else if (s.fadeOut > 0)
            {
                if (s.opacity > 0)
                    s.opacity -= s.fadeOut;
                if (s.opacity <= 0)                    
                {
                    s.fadeOut = 0;
                    s.opacity = 0;
                }
            }
        }
    }
}